export const titles = {
  readings: 'Спасибо! Показания переданы.',
  request: 'Заявка создана!',
};
